export default __webpack_public_path__ + "static/6754-ac43b425ad96635e874a1e6b9c07dc23.jpg";